import { combineReducers } from "redux";
import auth from "./auth";
// import landing from "./landing"

export default combineReducers({ auth/*, landing*/ });
